import { PDDatos } from './PDDatos';
import { PDTabla } from './PDTabla';
import { GlobalVars, CodTipDocPDF } from '../general/variables';

export class PlantillaDocumento {
    rutaArchivoPlantilla: string = GlobalVars.DscRutaArchivoPlant;
    nombreArchivoPlantilla: string;
    rutaArchivoGenerado: string = GlobalVars.DscRutaArchivoPlantGen;
    nombreArchivoGenerado: string;
    nombrePdfGenerado: string;
    tipoDocumento: string = CodTipDocPDF;
    datos: PDDatos[];
    grillas: PDTabla[];
    blgrillas  = '0';
    blimagenes = '1';

}
